import { formatCurrency } from "@/shared/lib/formatting/currency"

/**
 * A finance amount for the palette, or null when there is nothing to show: the server sends `null` when the
 * branch's figures are not disclosed to the caller, and the palette then shows no amount at all. The canonical
 * decimal string goes to the formatter untouched (never through a float).
 */
export function formatSearchAmount(
  amount: number | string | null | undefined,
  currency: string | null | undefined,
  locale: string,
): string | null {
  if (amount === null || amount === undefined || amount === "" || !currency) return null
  return formatCurrency(amount, currency, locale)
}
